import React, { useState } from 'react';
import { Accordion, AccordionItem } from './ui/Accordion';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Para qué edad es este programa?',
    a: 'Está diseñado idealmente para niños entre 4 y 9 años que están iniciando el proceso o que han tenido dificultades iniciales. Sin embargo, los principios funcionan para cualquier niño que necesite reforzar las bases fonológicas.'
  }, {
    q: '¿Necesito ser maestra para aplicarlo?',
    a: "¡Para nada! El manual está escrito específicamente para mamás y papás. No usamos jerga técnica complicada. Es un paso a paso claro: 'di esto', 'muestra esto', 'jueguen a esto'."
  }, {
    q: '¿Cuánto tiempo necesito por día?',
    a: 'El sistema está optimizado para sesiones cortas de 10 a 15 minutos. Sabemos que la atención de los niños es limitada y tu tiempo también. La constancia es más importante que la duración.'
  }, {
    q: '¿Es digital o me llega algo a casa?',
    a: 'Es un producto 100% digital. Recibes acceso inmediato a email donde puedes descargar todo el material junto a todos los bonos. Puedes imprimir lo que necesites o verlo desde tu tablet/celular.'
  }, {
    q: '¿Qué pasa si mi hijo ya sabe algunas letras?',
    a: "Perfecto. El programa le ayudará a consolidar lo que sabe y llenar los vacíos que puedan estar causando inseguridad. A menudo, los niños conocen las letras pero no saben 'qué hacer' con ellas para formar palabras."
  }];
  return <section className="py-20 px-4 bg-[#F5F1EA]" data-id="element-30">
      <div className="max-w-3xl mx-auto" data-id="element-31">
        <div className="text-center mb-12" data-id="element-32">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2D3648]" data-id="element-33">
            Preguntas Frecuentes
          </h2>
        </div>

        <Accordion data-id="element-34">
          {faqs.map((faq, index) => <AccordionItem key={index} title={faq.q} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-35">
              {faq.a}
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}